import React from 'react'
import { 
    CellsTitle, Cells, TextArea, CellBody, Form, FormCell, Button,
    Toast, Dialog, Toptips, Select
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import {WKVisible} from '../../components/wk'
import {TimeStream} from '../../utils'
import Header from '../../components/liveroomLecturer/Header'
import '../../css/page/ChannelLectureEditPage.css'


class ChannelEditTitlePage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            originStartTime: 0,
            startTime: 0,
            duration: 0.5,
            isAllowModify: true,
            isShowOutDialog: false,
            isCanSend: true,
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        this.fetchData()
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/lecture/${this.props.params.id}/edit_info`)
            .then(res => {
                this.setState({ 
                    duration: res.data.data.lecture.duration, 
                    originStartTime: res.data.data.lecture.start_timestamp,
                    startTime: res.data.data.lecture.start_timestamp,
                    isAllowModify: res.data.data.lecture.can_modify_start_time,
                    isCanSend: res.data.data.lecture.can_send_modify_start_time,
                    isPending: false,
                })
            })
    }
    onClickAlertOk () {
        axios.post(`/api/lecture/${this.props.params.id}/edit/start_time/notify`)
        browserHistory.go(-1)
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    onSubmit (e) {
        if (!this.state.isAllowModify && this.state.originStartTime !== this.state.startTime) {
            return this.setState({ isShowOutDialog: true })
        }
        if (!this.state.startTime) {
            return this.showTip('请填写开课时间')
        }
        if (this.state.startTime < Date.now() / 1000) {
            return this.showTip('开课时间不能早于当前时间')
        }
        this.setState({ isPending: true })
        axios.post(`/api/lecture/${this.props.params.id}/edit`, qs.stringify({
            start_time: this.state.startTime,
            duration: this.state.duration,
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.setState({
                    alertDialog: { isShow: true, text: res.data.msg }
                })
            })
    }
    onChangeStartTime (e) {
        const value = e.target.value.replace(/-/g,"/").replace(/T/g," ")
        const timestamp = Date.parse(value) / 1000
        this.setState({ startTime: timestamp })
    }
    getPushDialogBtns () {
        const { originStartTime, startTime, isCanSend } = this.state
        return (originStartTime !== startTime && isCanSend) ? [
            { label: '关闭', type: 'default', onClick: () => browserHistory.go(-1) },
            { label: '推送通知', onClick: () => this.onClickAlertOk() }
        ] : [
            { label: '关闭', onClick: () => browserHistory.go(-1) }
        ]
    }
    render() {
        return (
            <div className='page'>
                <div className="wk-inner-page channel-lecture-edit-page">
                    <div className="lecture-time-page">
                        <Header title='开课时间' />
                        <Form>
                            <FormCell>
                                <CellBody>
                                    <input
                                        className="time-input"
                                        onChange={e => this.onChangeStartTime(e)} 
                                        type="datetime-local" 
                                        value={TimeStream(this.state.startTime).replace(' ', 'T')} 
                                    />
                                </CellBody>
                            </FormCell>
                        </Form>
                        <p className="small-font intro">课程结束后不允许修改开课时间，开课前可以修改3次开课时间。</p>
                        <Header title='直播时长' />
                        <Form className='margin-bottom'>
                            <FormCell select>
                                <CellBody>
                                    <Select onChange={e => this.bindValue(e, 'duration')} value={this.state.duration}>
                                        <option value="30">0.5小时</option>
                                        <option value="60">1小时</option>
                                        <option value="120">2小时</option>
                                        <option value="180">3小时</option>
                                    </Select>
                                </CellBody>
                            </FormCell>
                        </Form>
                        <div className="wk-btn-90 padding-top-10">
                            <Button onClick={e => this.onSubmit()}>保存</Button>
                        </div>                        
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={this.getPushDialogBtns()} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text === 'ok' ? '修改成功' : this.state.alertDialog.text}
                </Dialog>
                <Dialog type="ios" title='' buttons={[
                    { label: '取消', type: 'default', onClick: () => this.setState({ isShowOutDialog: false }) },
                    { label: '联系客服', onClick: () => location.assign('/account/customer_service') }
                ]} show={this.state.isShowOutDialog}>
                    修改课程时间次数已用完，如有疑问请联系客服
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default ChannelEditTitlePage


// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditTimePage.js